import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deleteCustomer, useCustomers } from "../../utils/customer";
import { NavItem, NavTabs } from "../layout/Nav";
import { verifyRight } from "../../utils/users";
import { StyledTr } from "./bookingContent";
import ActionsMenu from "../layout/ActionsMenu";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { OutlineButtonLink } from "../layout/OutlineButton";

const getCivilityDisplay = (civilityCode) => {
  const civilityMap = {
    'mr': 'M.',
    'ms': 'Mme'
  };
  return civilityMap[civilityCode] || civilityCode || '-';
};

export default function CustomerContent() {
  const { userInfos } = useContext(UserContext);

  const { customers, loaded } = useCustomers();
  const [checked, setChecked] = useState([]);
  const datatable = useRef(null);

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[0, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [customers]);

  const datatableContent = useMemo(() => {
    return customers.map((customer) => {
      let actions = [];
      if (verifyRight(userInfos, "customer", "update")) {
        actions.push({
          label: "Modifier",
          link: `/passenger/${customer.id}`,
        });
      }

      if (verifyRight(userInfos, "customer", "delete")) {
        actions.push({
          label: "Supprimer",
          onClick: async () => {
            if (!window.confirm("Voulez-vous vraiment supprimer ce passager ?"))
              return;
            await deleteCustomer(userInfos, [customer.id]);
            window.location.reload();
          },
        });
      }

      return (
        <StyledTr
          key={customer.id}
          className={checked.includes(customer.id) ? "checked" : ""}
        >
          <td style={{ textAlign: "center" }}>
            <input
              type="checkbox"
              checked={checked.includes(customer.id)}
              name="bulk_action"
              value={customer.id}
              onChange={handleCheckbox}
            />
          </td>
          <td>{getCivilityDisplay(customer.civility)}</td>
          <td>{customer.firstname}</td>
          <td>{customer.lastname}</td>
          <td>{customer.email}</td>
          <td>{customer.emailLanguage || 'EN'}</td>
          <td>{customer.phone}</td>
          <td>{customer.comments}</td>
          <td>{customer.favoriteAddress1}</td>
          <td>{customer.favoriteAddress2}</td>
          <td>{customer.provider?.name || customer.provider?.firstname || ""}</td>
          <td>
            <ActionsMenu items={actions} />
          </td>
        </StyledTr>
      );
    });
  }, [checked, customers, userInfos]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const handleDeleteCustomer = useCallback(async () => {
    if (!window.confirm("Voulez-vous vraiment supprimer ces passagers ?"))
      return;
    await deleteCustomer(userInfos, checked);
    window.location.reload();
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    if (checked.length > 0) {
      let actions = [];
      if (verifyRight(userInfos, "customer", "delete")) {
        actions.push({
          label: <TrashIcon />,
          onClick: handleDeleteCustomer,
        });
      }

      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={actions}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeleteCustomer, userInfos]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <NavTabs className="titles">
          {verifyRight(userInfos, "provider", "read") && (
            <NavItem>
              <Link to="/provider">Clients</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "customer", "read") && (
            <NavItem className="active">
              <Link to="/passenger">Passagers</Link>
            </NavItem>
          )}
        </NavTabs>
        <div className="header-toolbar">
          {verifyRight(userInfos, "customer", "create") && (
            <OutlineButtonLink to="/addCustomer/">
              <i className="la la-plus"></i>
              Nouveau passager
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="">
          <div className="kt-portlet__body">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table table-striped- table-bordered table-hover table-checkable"
                id="datatable"
              >
                <thead>
                  <tr>
                    <th
                      style={{ width: "2%", textAlign: "center" }}
                      data-sort="false"
                    >
                      Selection
                    </th>
                    <th style={{ width: "5%" }}>Civilité</th>
                    <th style={{ width: "10%" }}>Prénom</th>
                    <th style={{ width: "10%" }}>Nom</th>
                    <th style={{ width: "15%" }}>Email</th>
                    <th style={{ width: "5%" }}>Langue</th>
                    <th style={{ width: "8%" }}>Téléphone</th>
                    <th style={{ width: "12%" }}>Commentaire</th>
                    <th style={{ width: "12%" }}>Adresse Fav 1</th>
                    <th style={{ width: "12%" }}>Adresse Fav 2</th>
                    <th style={{ width: "12%" }}>Client</th>
                    <th style={{ width: "5%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>{datatableContent}</tbody>
              </table>
            </div>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
